import { FC, PropsWithChildren } from "react";
import Card from "./Card";
import styles from "./SectionCard.module.css";

type SectionCardProps = PropsWithChildren<{
  title?: string;
}>;

const SectionCard: FC<SectionCardProps> = ({ title, children }: SectionCardProps) => (
  <Card className={styles.section}>
    {!!title && (
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
      </div>
    )}
    <div className={styles.content}>{children}</div>
  </Card>
);

export default SectionCard;
